export default __webpack_public_path__ + "static/vanilla-glaze-doughnut2-c383b6fdc93a526059c805c1fa2e855c.png";